import { Col, Row } from "antd";
import React, { useMemo } from "react";
import { GET_STORE_REJECTED_URL, GET_STORE_UPDATE_REJECTED_URL } from "../../commons/constants/api-urls";
import useFetchList from "../../commons/hooks/useFetchList";
import { Store } from "../../commons/resources";
import StoreCard from "./StoreCard";
import styles from "./store-management.module.scss";
import { STORE_TYPE_TABS } from ".";
import { STORE_TYPE } from "../../commons/constants/store";

interface Props {
  activeTab: string;
  activeTypeTab: string;
}

const StoreRejected: React.FC<Props> = ({ activeTab, activeTypeTab }) => {
  const { data: createRejected, loading: loadingCreateRejected } = useFetchList<Store>(GET_STORE_REJECTED_URL, {
    pageSize: 100,
    perPage: 100,
  });

  const { data: updateRejected, loading: loadingUpdateRejected } = useFetchList<Store>(GET_STORE_UPDATE_REJECTED_URL, {
    pageSize: 100,
    perPage: 100,
  });

  const listStore = useMemo(() => {
    const returnData = [...createRejected, ...updateRejected];
    if (activeTypeTab === STORE_TYPE_TABS.ALL) {
      return returnData;
    }

    let storeType: string = STORE_TYPE.FOOD_DELIVERY;
    switch (activeTypeTab) {
      case STORE_TYPE_TABS.FOOD_DELIVERY:
        storeType = STORE_TYPE.FOOD_DELIVERY;
        break;
      case STORE_TYPE_TABS.SURPLUS:
        storeType = STORE_TYPE.SURPLUS;
        break;

      default:
        break;
    }

    return returnData.filter(item => item.type && item.type === storeType);
  }, [activeTypeTab, createRejected, updateRejected]);

  const loading = loadingCreateRejected || loadingUpdateRejected;

  return (
    <div>
      {" "}
      {!loading ? (
        listStore.length === 0 ? (
          <div className={styles.emptyList}>
            <img className={styles.image} src={Store} alt="store" />
            <div className={styles.title}>Great news!</div>
            <div className={styles.description}>All stores are approved—no rejections yet.</div>
          </div>
        ) : (
          <>
            <Row gutter={[24, 12]} style={{ marginTop: 30 }}>
              {listStore.map((store: Store, index: number) => (
                <Col key={store.id} span={6} lg={6} md={12} xs={24}>
                  <StoreCard
                    key={index}
                    storeName={store.name}
                    image={store.logo}
                    reasonReject={store?.rejectedReason}
                    storeType={store.type as STORE_TYPE}
                  />
                </Col>
              ))}
            </Row>
          </>
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default StoreRejected;
